// 
export const PURCHASE_LIST = 'PURCHASE_LIST';
export const PURCHASE_PAGINATION = 'PURCHASE_PAGINATION';
